import { UuiDialog } from "@aonunited/react";
import React, { useEffect } from "react";
import "./AonDialog.component.scss";
var AonDialog = function (_a) {
    var extraClass = _a.extraClass, dismissOnEsc = _a.dismissOnEsc, dismissOnOverlay = _a.dismissOnOverlay, enableBackgroundScroll = _a.enableBackgroundScroll, opened = _a.opened, trigger = _a.trigger, header = _a.header, body = _a.body, footer = _a.footer;
    //removing the overriding body style on unmounting the Dialog
    useEffect(function () {
        return function () {
            document.body.style.removeProperty("position");
            document.body.style.removeProperty("width");
            document.body.style.removeProperty("overflow-y");
            //document.body.style.overflowY="hidden";
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(UuiDialog, { className: "aon-dialog ".concat(extraClass ? extraClass : ""), dismissOnEsc: dismissOnEsc, dismissOnOverlay: dismissOnOverlay, enableBackgroundScroll: enableBackgroundScroll, opened: opened, renderTrigger: false },
            trigger && React.createElement("div", { slot: "trigger" }, trigger),
            header && React.createElement("div", { slot: "header" },
                " ",
                header),
            body && React.createElement("div", { slot: "body" },
                " ",
                body),
            footer ? React.createElement("div", { slot: "footer" },
                " ",
                footer) : null)));
};
export { AonDialog };
